import React from 'react';
import { InfoOutlined } from '@ant-design/icons';
import './week-calendar-item.css';
import { cnvMinutesToTimeString } from '../../extensions/utils';

const WeekCalendarItem = ({ ...props }) => {
    const {
        productName,
        roomName,
        sotrName,
        color,
        startMin,
        finishMin,
        id,
        comment,
        productId,
        sotrImageId,
        sotrDescription,
        onItemClick,
        dayIndex,
        frame,
        pending,
    } = props;
    const time = `${cnvMinutesToTimeString(startMin)} - ${cnvMinutesToTimeString(finishMin)}`;
    const title = comment || productName;
    const showInfo = Boolean(productId || sotrImageId || sotrDescription);
    const className = [
        'week-calendar-item',
        frame ? 'week-calendar-item--stretch' : '',
        pending ? 'week-calendar-item--stretch-pending' : '',
    ]
        .filter(Boolean)
        .join(' ');
    const style = {
        ...(color ? { borderLeftColor: color } : null),
        ...(frame ? { top: frame.top, left: frame.left, width: frame.width, height: frame.height } : null),
    };

    return (
        <div
            className={className}
            style={style}
            data-item-id={id}
            data-start-min={startMin}
            data-finish-min={finishMin}
            data-day={dayIndex == null ? undefined : dayIndex}
            data-stretch-candidate={pending ? '1' : undefined}
            onClick={() => onItemClick(id)}
        >
            {showInfo && (
                <span className='week-calendar-item-cart' aria-hidden='true'>
                    <InfoOutlined />
                </span>
            )}
            <div className='product'>{title}</div>
            <div className='time'>{time}</div>
            {roomName ? <div className='room'>{roomName}</div> : null}
            {sotrName ? <div className='sotr'>{sotrName}</div> : null}
        </div>
    );
};

export default WeekCalendarItem;
